shadow$provide[424] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying float vPixelSize;

float getTriangleUpMask(vec2 uv) {
  uv.y -= .25;
  return max(-uv.y, abs(uv.x) * .866 + uv.y * .5 + .6);
}
`;

};